export const baseUrl = "https://interface-zrkpgu7tan.flashift.app/api/web/v4/";
